const FreePlaces = {
    clarissa: {
        2026: {
            total: 4,
            free: 0,
        },
        2027: {
            total: 4,
            free: 0,
        },
        2028: {
            total: 4,
            free: 4,
        },
    },
    sabine: {
        2026: {
            total: 5,
            free: 0,
        },
        2027: {
            total: 5,
            free: 0,
        },
        2028: {
            total: 5,
            free: 5,
        },
    },
};

export default FreePlaces;
